document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.skin-single__float-slider');

    sliders.forEach(function (slider) {
        const track = slider.querySelector('.skin-single__float-track-inner');
        const handle = slider.querySelector('[data-float-handle]');
        const valueEl = slider.querySelector('[data-float-value]');
        const exteriorEl = slider.querySelector('[data-exterior-label]');
        const article = slider.closest('.skin-single__article');
        const galleryImgs = article
            ? article.querySelectorAll('.skin-single__gallery-main img[data-img-index]')
            : null;

        if (!track || !handle || !valueEl || !galleryImgs || !galleryImgs.length) {
            return;
        }

        // Parse min/max floats from data attributes
        const minRaw = parseFloat(slider.dataset.minFloat || '0') || 0;
        const maxRaw = parseFloat(slider.dataset.maxFloat || '1') || 1;

        const minFloat = Math.max(0, Math.min(1, minRaw));
        const maxFloat = Math.max(0, Math.min(1, maxRaw > minFloat ? maxRaw : minFloat + 0.1));

        let exteriorOrder = ['Factory New', 'Minimal Wear', 'Field-Tested', 'Well-Worn', 'Battle-Scarred'];
        try {
            const parsed = JSON.parse(slider.dataset.exteriorOrder || '[]');
            if (Array.isArray(parsed) && parsed.length === 5) {
                exteriorOrder = parsed;
            }
        } catch (e) { }

        // Segment definitions (0→1)
        const segments = [
            { start: 0.00, end: 0.07, color: '#22c55f', exteriorIndex: 0 }, // Factory New
            { start: 0.07, end: 0.15, color: '#84cc15', exteriorIndex: 1 }, // Minimal Wear
            { start: 0.15, end: 0.38, color: '#ebb30b', exteriorIndex: 2 }, // Field-Tested
            { start: 0.38, end: 0.45, color: '#fa7315', exteriorIndex: 3 }, // Well-Worn
            { start: 0.45, end: 1.00, color: '#ef4444', exteriorIndex: 4 }  // Battle-Scarred
        ];

        // Boundaries between segments (for crossfade)
        const boundaries = [segments[0].start]; // usually 0
        segments.forEach(seg => {
            boundaries.push(seg.end);
        });
        // Example: [0, 0.07, 0.15, 0.38, 0.45, 1]

        // CSS variables for disabled/active ranges (used in SCSS)
        slider.style.setProperty('--min-float', String(minFloat));
        slider.style.setProperty('--max-float', String(maxFloat));

        let currentValue = minFloat + (maxFloat - minFloat) / 10;

        function valueToPercent(value) {
            return Math.min(100, Math.max(0, value * 100));
        }

        function findSegmentIndex(value) {
            for (let i = 0; i < segments.length; i++) {
                const seg = segments[i];
                if (value >= seg.start && value < seg.end) {
                    return i;
                }
            }
            return segments.length - 1;
        }

        function updateImages() {
            const nImgs = galleryImgs.length;
            if (!nImgs) return;

            // Reset all opacities
            galleryImgs.forEach(img => {
                img.style.opacity = '0';
            });

            const v = currentValue;

            // Below first or above last boundary: just show first/last
            if (v <= boundaries[0]) {
                galleryImgs[0].style.opacity = '1';
                return;
            }
            if (v >= boundaries[boundaries.length - 1]) {
                galleryImgs[nImgs - 1].style.opacity = '1';
                return;
            }

            // Find which boundary interval we're in
            let k = 0;
            for (let i = 0; i < boundaries.length - 1; i++) {
                if (v >= boundaries[i] && v <= boundaries[i + 1]) {
                    k = i;
                    break;
                }
            }

            let prevIndex = Math.min(k, nImgs - 1);
            let nextIndex = Math.min(k + 1, nImgs - 1);

            if (prevIndex === nextIndex) {
                galleryImgs[prevIndex].style.opacity = '1';
                return;
            }

            const start = boundaries[k];
            const end = boundaries[k + 1];
            const span = end - start || 1;
            let t = (v - start) / span;
            t = Math.max(0, Math.min(1, t));

            // Adjusted blending to avoid dark midpoints:
            // - previous image goes 1 → 0.7
            // - next image goes 0 → 0.7
            const prevOpacity = 1 - 0.3 * t;   // 1.0 down to 0.7
            const nextOpacity = 0.7 * t;       // 0.0 up to 0.7

            galleryImgs[prevIndex].style.opacity = String(prevOpacity);
            galleryImgs[nextIndex].style.opacity = String(nextOpacity);
        }

        function updateUI() {
            handle.style.left = valueToPercent(currentValue) + '%';
            valueEl.textContent = currentValue.toFixed(4);

            // Exterior label: choose segment we are in
            const segIndex = findSegmentIndex(currentValue);
            const seg = segments[segIndex];
            const exteriorIndex = seg.exteriorIndex;
            const exteriorName = exteriorOrder[exteriorIndex] || '';

            if (exteriorEl) {
                exteriorEl.textContent = exteriorName;
            }

            updateImages();
        }

        function setValueFromClientX(clientX) {
            const rect = track.getBoundingClientRect();
            if (!rect.width) {
                return;
            }

            let ratio = (clientX - rect.left) / rect.width;
            ratio = Math.min(1, Math.max(0, ratio));

            // Convert ratio (0–1) to global [0–1] value
            let globalValue = ratio;

            // Clamp to active range [minFloat, maxFloat]
            if (globalValue < minFloat) {
                globalValue = minFloat;
            } else if (globalValue > maxFloat) {
                globalValue = maxFloat;
            }

            currentValue = globalValue;
            updateUI();
        }

        function startDrag(startEvent) {
            startEvent.preventDefault();

            const move = function (moveEvent) {
                const clientX = moveEvent.touches
                    ? moveEvent.touches[0].clientX
                    : moveEvent.clientX;

                setValueFromClientX(clientX);
            };

            const stop = function () {
                document.removeEventListener('mousemove', move);
                document.removeEventListener('touchmove', move);
                document.removeEventListener('mouseup', stop);
                document.removeEventListener('touchend', stop);
            };

            document.addEventListener('mousemove', move);
            document.addEventListener('touchmove', move, { passive: false });
            document.addEventListener('mouseup', stop);
            document.addEventListener('touchend', stop);
        }

        track.addEventListener('mousedown', startDrag);
        track.addEventListener('touchstart', startDrag, { passive: false });

        // Initial render
        updateUI();
    });
});
